import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export function CTABanner() {
  return (
    <section className="container-px mx-auto max-w-7xl py-16 lg:py-24">
      <Reveal className="relative overflow-hidden rounded-3xl bg-primary px-8 py-14 sm:px-14 lg:px-20 lg:py-20">
        <div className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-accent/20 blur-2xl" />
        <div className="absolute -bottom-20 -left-10 h-72 w-72 rounded-full bg-secondary/30 blur-3xl" />
        <div className="relative flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <p className="overline text-accent">Let's work together</p>
            <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-white text-balance">
              Ready to power your business with a trusted partner?
            </h2>
            <p className="mt-4 text-slate-200 leading-relaxed">
              Tell us what you need and our team will respond with a tailored solution and competitive quote.
            </p>
          </div>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-full bg-accent px-7 py-3.5 text-sm font-semibold text-[#06281A] shadow-lg transition-transform duration-300 hover:scale-105"
              data-testid="cta-banner-quote-btn"
            >
              Request a Quote <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 rounded-full border border-white/30 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10"
              data-testid="cta-banner-services-btn"
            >
              Explore Services
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
